module.exports = __webpack_public_path__ + "static/media/Messenger_Guide_Chin.77a319ea.pdf";